import { render, staticRenderFns } from "./channel.schedule.vue?vue&type=template&id=116921e6&"
import script from "./channel.schedule.vue?vue&type=script&lang=js&"
export * from "./channel.schedule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports